import { faCheck, faCopy, faFolderTree } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { getCsrfToken } from "../state/csrf";

type Credential = { username: string; secret: string; url: string };

const Field = ({ label, value }: { label: string; value: string }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div className="flex gap-2 items-center">
      <span className="text-[11px] uppercase tracking-wide text-gray-500 w-20 shrink-0">
        {label}
      </span>
      <input
        readOnly
        value={value}
        onFocus={(e) => e.currentTarget.select()}
        className="flex-1 px-2 py-1 border rounded text-xs font-mono bg-white"
      />
      <button
        onClick={copy}
        className="inline-flex items-center gap-1 px-2 py-1 bg-green text-white rounded text-xs hover:bg-dark-green"
        title="Kopieer"
      >
        <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
      </button>
    </div>
  );
};

export const WebDavLink = () => {
  const [open, setOpen] = useState(false);
  const [cred, setCred] = useState<Credential | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const generate = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await fetch("/api/dav/token", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRFToken": getCsrfToken() },
        body: JSON.stringify({ label: "browser" }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      setCred(await r.json());
    } catch {
      setError("Kon geen link genereren");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div ref={ref} className="float-right mr-12 relative" style={{ marginTop: "-50px" }}>
      <button
        onClick={() => setOpen(!open)}
        className="px-1 py-1 rounded text-white bg-green hover:bg-green-800"
        title="WebDAV-koppeling"
      >
        <FontAwesomeIcon icon={faFolderTree} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-auto p-3 bg-white border border-gray-200 rounded shadow-lg z-20 space-y-2">
          {cred ? (
            <>
              <p className="text-xs text-gray-600">
                Koppel als netwerkschijf. Deze link is eenmalig.
              </p>
              <Field label="URL" value={cred.url} />
              <Field label="Username" value={cred.username} />
              <Field label="Password" value={cred.secret} />
            </>
          ) : (
            <>
              <button
                onClick={generate}
                disabled={loading}
                className="inline-flex items-center gap-2 text-sm text-green hover:text-dark-green disabled:opacity-50"
              >
                <FontAwesomeIcon icon={faFolderTree} />
                {loading ? "Bezig..." : "Genereer WebDAV-koppeling"}
              </button>
              {error && <p className="text-xs text-red-500">{error}</p>}
            </>
          )}
        </div>
      )}
    </div>
  );
};
